import React from 'react'
import { useTranslation } from 'react-i18next'
import link from '@/assets/images/link.svg'
import { menuItems } from './config'
import { SubLinksMenu } from './components/SubLinksMenu'

export const MenuNavigation = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation()
  const userId = localStorage.getItem('userId') || ''

  return (
    <ul className="flex-shrink basic-auto flex flex-col justify-between">
      {menuItems(userId).map((item) => {
        return (
          <li key={item.anchor} className="py-[13px] px-4">
            {item.sublinks && (
              <SubLinksMenu title={item.anchor} sublinks={item.sublinks} onClose={onClose} />
            )}

            {item.href && (
              <a
                target={!item.href.includes('mailto') ? '_blank' : undefined}
                rel={!item.href.includes('mailto') ? 'noreferrer noopener' : undefined}
                href={item.href}
                className="transition-all hover:text-primary leading-[140%] flex items-center justify-between text-xl3 font-semibold"
              >
                <span>{t(item.anchor as any)}</span>
                <img className="size-10" width="40" height="40" src={link} alt="link" />
              </a>
            )}
          </li>
        )
      })}
    </ul>
  )
}
